export default "__VITE_ASSET__be721deb__"